import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const trustItems = ['Instant digital download', '7-day money-back guarantee', 'One-time payment'];
export function Hero() {
  return <section className="flex min-h-[calc(100svh-44px)] w-full flex-col justify-center bg-cream px-6 pb-7 pt-6 sm:min-h-0 sm:px-5 sm:pb-16 sm:pt-14" data-id="element-110" data-mp="9llat1xpw6pm">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-111" data-mp="129h19owp12dy">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.16em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-112" data-mp="1274mtlq59a5n">
          The Complete Beginner Yoga Teaching System
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-3 text-[29px] font-extrabold leading-[1.1] tracking-tight text-teal sm:mt-5 sm:text-5xl lg:text-[3.4rem] lg:leading-[1.08]" data-id="element-113" data-mp="3d2bjjokooxv0">
          Teach Your First Year of Beginner Yoga in Just{' '}
          <span className="text-terracotta" data-id="element-114" data-mp="39authk0ozz0e">5 Minutes</span> of Prep
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-3 max-w-3xl text-[14px] leading-[1.5] text-ink-soft sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-115" data-mp="3e961dp7ffzfz">
          <span className="sm:hidden" data-id="element-116" data-mp="35akifsy1mieo">
            Yoga With Tina is a complete, ready-to-teach beginner system — 6 volumes packed with
            sequences, real-body adaptations and cueing scripts. Just open, prep, and teach.
          </span>
          <span className="hidden sm:inline" data-id="element-117" data-mp="2hk86m6zog1it">
            Yoga With Tina gives newly certified yoga teachers everything they need to teach, adapt,
            and connect with beginner students — 6 complete volumes packed with ready-to-teach
            sequences, real-body adaptations, cueing scripts, and the confidence tools your
            certification didn't cover.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-5 w-full sm:mt-10" data-id="element-118" data-mp="id03uq2uq4o4">
          <img src="https://cdn.magicpatterns.com/uploads/hNpkVPDGD7hJ3LsDzgsoVm/ChatGPT_Image_3_ago_2026,_01_27_35_p.m.-Photoroom.png" alt="The Yoga Ready With Tina bundle: six spiral-bound yoga teaching volumes with the curriculum on desktop, a sequence guide on tablet, and inspiration content on mobile" className="mx-auto max-h-[34svh] w-auto max-w-full object-contain sm:max-h-none sm:w-full" width={1232} height={1232} data-id="element-119" data-mp="1b049mx9rqn0y" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-4 w-full sm:mt-9" data-id="element-120" data-mp="3htpwzoqzgekv">
          <CTAButton data-id="element-121" data-mp="269zfdkix2hk6" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] text-ink-soft sm:mt-6 sm:gap-x-4 sm:text-sm" data-id="element-122" data-mp="269r41x2fzkb3">
            {trustItems.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-123" data-mp="2g0lrv5vc6ryn" data-mpi={index}>
                {index > 0 && <span aria-hidden="true" className="text-ink-soft/50" data-id="element-124" data-mp="2ky44b68kbpbe">
                    ·
                  </span>}
                <span className="flex items-center gap-1" data-id="element-125" data-mp="2p1a6o2sk0wcl">
                  <span aria-hidden="true" className="font-bold text-sage" data-id="element-126" data-mp="2tztuk8qpki7l">
                    ✓
                  </span>
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}